
import { useQuery } from "@tanstack/react-query";
import { fetchClips } from "@/utils/supabase/dataFetching";

export const usePlaylistClips = (playlistId: string, limit: number = 20) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['playlistClips', playlistId, limit],
    queryFn: async () => {
      console.log(`Fetching clips for playlist: ${playlistId}`);
      const clips = await fetchClips(playlistId, limit);
      console.log(`Fetched ${clips?.length || 0} clips`);
      return clips;
    },
    enabled: !!playlistId
  });

  return {
    clips: data || [],
    isLoading,
    error: error ? (error as Error).message : null
  };
};
